import React from "react";
import Helmet from "react-helmet";
import { useTranslation } from "@fortius/prime-ui";

export interface IAppTitle {
  concat?: string;
}

export const AppTitle: React.FC<IAppTitle> = ({concat}) => {
  const { t: translate } = useTranslation();

  return (
    <Helmet>
      <title>{`${translate("signup.appName")}` + (concat ? ` | ${concat}` : "")}</title>
    </Helmet>
  );
};
